import { type IRadioButtonProps } from "@msidentity/SISU/components/inputs/radio-button";
import {
  type UsernameRecoveryProofState,
  useUsernameRecoveryContext,
} from "../username-recovery-context";
import { UsernameRecoveryResultAliasType } from "../username-recovery-types";
import { type SelectedRecoveryAlias } from "../views/select-alias/username-recovery-select-alias-view-types";

export type AliasListRadioOptions = Omit<IRadioButtonProps, "onChange"> & {
  showInput: boolean;
};

/**
 * Custom hook for getting filtered accounts.
 * @param selectedAlias - selected alias
 * @returns filtered accounts for proof result
 */
export const useSelectAliasFilteredAccounts = function useSelectAliasFilteredAccounts(
  selectedAlias: SelectedRecoveryAlias | undefined,
) {
  const {
    viewState: { proofState },
  } = useUsernameRecoveryContext();
  const { aliases } = proofState;

  const filteredAliases = aliases.filter((alias) =>
    [UsernameRecoveryResultAliasType.Email, UsernameRecoveryResultAliasType.Phone].includes(
      alias.type,
    ),
  );
  const isMultipleAliases = filteredAliases.length > 1;

  const filteredAccountsForProofResult: UsernameRecoveryProofState = {
    ...proofState,
    aliases: filteredAliases,
  };

  const radioOptions: AliasListRadioOptions[] = filteredAliases.map(
    (alias, index): AliasListRadioOptions => {
      const value = `${alias.name}${index}`;
      const showInput = !!(
        selectedAlias &&
        value === `${selectedAlias.alias.name}${selectedAlias.index}` &&
        !selectedAlias.alias.isUnmasked
      );
      return {
        id: `recoveryAliasOption${index}`,
        label: alias.name,
        name: "recovery-alias-methods",
        value,
        hidden: false,
        disabled: false,
        showInput,
      };
    },
  );

  return { filteredAccountsForProofResult, isMultipleAliases, radioOptions };
};
